import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { ISiteTimerModel } from '../models'

export class UpdateTimerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/general/siteTimerUpdate',
      requesterInfo,
    })
  }

  public async timerUpdate(req: ISiteTimerModel): Promise<ISiteTimerModel[]> {
    return await this.postAsync<ISiteTimerModel[]>(req)
  }
}
